export const lazyIframeModal = (modalId, customConfigLink) => {

  const iframe = document?.querySelector(modalId + ' iframe') || null
  const iframeConfigLink = customConfigLink || iframe?.getAttribute('data-src')

  iframeConfigLink &&
  iframe.setAttribute('src', iframeConfigLink)

  return lazyIframeModal;
}
